import React from 'react';
import propTypes from 'prop-types';
import Row from './Row';

const ContentRows = ({ data, windowId }) => {
	return (
		<div className="container">
			{data.rows.map((row, i) => {
				const keyVal = `${windowId}-row${i}`;
				return (
					<Row
						key={keyVal}
						rowKey={keyVal}
						className={row.classes}
						columns={row.columns}
					/>
				);
			})}
		</div>
	);
};

export default ContentRows;

ContentRows.propTypes = {
	data: propTypes.shape({
		rows: propTypes.arrayOf(
			propTypes.shape({
				columns: propTypes.arrayOf(propTypes.object).isRequired,
				className: propTypes.shape({})
			})
		).isRequired
	}).isRequired,
	windowId: propTypes.string.isRequired
};
